<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="bg-bg_outline text-black-70 p-6">
    <app-modal-header-ui [title]="title"></app-modal-header-ui>
    <div class="dialog-body">
        <app-image-upload-ui [disabled]="true" [fetchedPhoto]="fetchedPhoto" [componentName]="'modal'"></app-image-upload-ui>
    </div>
</div>